import { useState, useEffect } from 'react';
import ItemsBase from '../Items/ItemsBase';
import { CElement, TFlavor } from '@ts/ui-models';
import { useAppDispatch } from '@redux/store';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { IConfigComponent } from '@ts/ui-models';
import { TInheritedProps, IDataGridProps, TTextType } from '@ts/storybook';

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'itemsBase',
  aclId: 'tsElement',
  defaultId: 'itemsBase',
  entity: 'item',
  fetchURL: '/api/v2/items',
  crudURL: '/api/v2/item',
  mainClass: CElement,
};

interface IItemsProps {
  flavorId?: TFlavor;
  nameColumns?: string[]; //extraColumns to items
  title?: TTextType; //title to DataGrid
  fetchData?: string;
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  row?: any; //ForChildren?
  propsDataGrid?: IDataGridProps<false>['propsDataGrid'];
  defaultProps?: any;
}

const Items = (props: IItemsProps) => {
  const { row } = props;
  const dispatch = useAppDispatch();
  const [childIDs, setChildIDs] = useState<any[] | null>(null);

  const tElementParent = row ? new CElement(row) : null;

  useEffect(() => {
    const getIDsChildrenFromIdParent = async () => {
      if (tElementParent) {
        const dataChildren = (
          await dispatch(
            fetchData({
              //key: 'fetchChildren',
              url: `/api/v2/item/${tElementParent.getID()}/children`,
              dataBody: { findAndCount: false, where: { isAlive: true } },
            })
          )
        ).payload?.data;
        const listIDs = dataChildren?.map(d => d.childElementId);
        setChildIDs(listIDs);
      } else {
        setChildIDs([]);
      }
    };
    getIDsChildrenFromIdParent();
  }, []);

  if (!childIDs && tElementParent) return;

  const mergeConfigComponent = {
    ...defaultConfigComponent,
    ...props.configComponent,
    ...(row && { componentId: `${tElementParent?.mainFlavor}Children` }),
    ...(row && childIDs && childIDs.length > 0 && { where: { logicalId: childIDs } }),
  };

  const defaultProps = {
    flavorId: props.flavorId || ('allItem' as TFlavor),
    nameColumns: props.nameColumns || ['defaultLocation', 'currentLocation', 'lastPosition'],
  };

  return <ItemsBase {...defaultProps} {...props} configComponent={mergeConfigComponent} />;
};

export default Items;
